/**
 * Custom BubbleChartComponent - Override Component
 * Extends parent from shared library
 * OVERRIDE: Changed bubble color to pink
 */
import { Component, AfterViewInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as echarts from 'echarts';
import { BubbleChartComponent as ParentBubbleChartComponent } from '@shared-lib/chart-components/bubble-chart/bubble-chart.component';
import { ConfigService } from '@shared-lib/shared-services/config.service';
import { GlobalFilterService } from '@shared-lib/shared-services/global-filter-service';
import { ChartFilterHandlerService } from '@shared-lib/shared-services/chart-filter-handler.service';

@Component({
  selector: 'app-bubble-chart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bubble-chart.component.html',
  styleUrls: ['./bubble-chart.component.scss']
})
export class BubbleChartComponent extends ParentBubbleChartComponent implements AfterViewInit, OnDestroy {

  private customChart!: echarts.ECharts;

  constructor(
    private customConfigService: ConfigService,
    private customGlobalFilterService: GlobalFilterService,
    protected override chartFilterHandler: ChartFilterHandlerService
  ) {
    super(customConfigService, customGlobalFilterService, chartFilterHandler);

    // Subscribe to filter changes
    this.customGlobalFilterService.filter$.subscribe((filters) => {
      if (Object.keys(filters).length !== 0) {
        this.loadCustomChart(filters);
      }
    });
  }

  override ngAfterViewInit(): void {
    this.loadCustomChart();
  }

  private loadCustomChart(filters?: any): void {
    const chartDom = document.getElementById(this.data.widgetId);
    if (!chartDom) return;

    if (!this.customChart) {
      this.customChart = echarts.init(chartDom);
    }

    this.customChart.showLoading();

    this.customConfigService.getConfig(this.data.apiUrl, filters).subscribe({
      next: (res) => {
        this.renderCustomChart(res?.data);
      },
      error: () => {
        this.customChart.hideLoading();
      }
    });
  }

  private renderCustomChart(chartData?: { points: any[] }): void {
    const option = {
      tooltip: {
        trigger: 'item',
        formatter: function (params: any) {
          const [gdp, lifeExp, pop, country] = params.data;
          return `
          <strong>${country}</strong><br/>
          GDP: ${gdp}<br/>
          Life Expectancy: ${lifeExp}<br/>
          Population: ${pop}
        `;
        }
      },
      xAxis: {
        scale: true,
        min: 0
      },
      yAxis: {
        scale: true,
        min: 60
      },
      series: [
        {
          type: 'scatter',
          data: chartData?.points,
          symbolSize: function (data: any[]) {
            return Math.sqrt(data[2]) / 100;
          },
          emphasis: {
            focus: 'series',
            label: {
              show: true,
              formatter: (param: any) => param.data[3],
              position: 'top'
            }
          },
          // OVERRIDE: Changed color from '#5470C6' to pink
          itemStyle: { color: '#d18aaeff' }
        }
      ]
    };

    this.customChart.setOption(option);
    setTimeout(() => {
      this.customChart.hideLoading();
    }, 1000);

    window.addEventListener('resize', () => this.customChart?.resize());
  }

  override ngOnDestroy(): void {
    this.customChart?.dispose();
  }
}
